<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  export let socials:
    | {
        type: string;
        value: string;
      }[]
    | null;

  const socialTypes = ['instagram', 'x', 'facebook', 'linkedin'];
  const getSocials = (socials: { type: string; value: string }[]) =>
    socials.filter((social) => socialTypes.includes(social.type));

  $: preparedSocials = socials ? getSocials(socials) : [];
</script>

{#if preparedSocials.length}
  <article class="mt-12 self-end lg:mb-0">
    <p class="text-default-500 mb-6 text-sm font-medium uppercase">Follow us</p>

    <ul class="flex gap-8">
      {#each preparedSocials as social}
        <li class="mb-3">
          <a href="{social.value}" target="_blank" class="hover:text-default-500 transition-colors" rel="nofollow">
            <Icon name="{social.type}" />
          </a>
        </li>
      {/each}
    </ul>
  </article>
{/if}
